import CloseIcon from "@mui/icons-material/Close";
import { Alert, IconButton } from "@mui/material";
import { COLOR_BLACK, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_ROBOTO } from "helpers/FONT";
import React, { useState } from "react";

export default function ArchiveVideoNotification() {
  const COOKIE_NAME = "GloryLeagueHideNotificationAlert";
  const [hide, setHide] = useState(() => {
    if (typeof document === "undefined") {
      return false;
    }
    return Boolean(document.cookie.split("; ").find((row) => row.startsWith(COOKIE_NAME + "=")));
  });

  if (hide) return null;

  const closeNotification = () => {
    setHide(true);
    document.cookie = `${COOKIE_NAME}=1; path=/; max-age=31536000; Secure; SameSite=Lax`;
  };

  return (
    <Alert
      severity="info"
      variant="filled"
      style={{
        backgroundColor: COLOR_BLACK,
        color: COLOR_WHITE,
        fontFamily: FONT_FAMILY_ROBOTO,
        display: "flex",
        alignItems: "center",
        borderRadius: 0,
      }}
      action={
        <IconButton aria-label="close" onClick={closeNotification} size="small" sx={{ color: COLOR_WHITE }}>
          <CloseIcon />
        </IconButton>
      }
    >
      <div style={{ flex: 1 }}>
        <>
          From 1 April 2026, videos older than 12 months will be automatically deleted. Highlights will still be
          available.{" "}
          <a
            target="_blank"
            href="https://gloryleague.basketball/support/video-storage-policy"
            style={{ color: COLOR_WHITE }}
            rel="noopener noreferrer"
          >
            Read More
          </a>
        </>
      </div>
    </Alert>
  );
}
